import cn from 'classnames';
import upperFirst from 'lodash/upperFirst';
import {
  ISSUER_NAME,
  PARENT_NAME,
  RATING_AGENCY_NAME,
  UNDERWRITER_NAME,
} from '@/creditflowresearch/ui/components/TopCompanies/constants';
import tabsStyles from '@creditflowresearch/uilib/styles/tabs.module.scss';

const getTopCompaniesTabs = (isCorporate: boolean) => ([
  {
    name: isCorporate ? PARENT_NAME : ISSUER_NAME,
    title: 'Issuers',
  },
  {
    name: RATING_AGENCY_NAME,
    title: 'Rating Agencies',
  },
  {
    name: UNDERWRITER_NAME,
    title: 'Underwriters',
  },
]);

interface ITopCompaniesTabsProps {
  isAccessible?: boolean,
  activeTab: string,
  onClick: (tabName: string) => void,
  isCorporate: boolean,
}

const TopCompaniesTabs = ({
  isAccessible = true,
  activeTab,
  onClick,
  isCorporate = false,
}: ITopCompaniesTabsProps) => (
  <>
    { getTopCompaniesTabs(isCorporate).map(({ name, title }) => (
      <button
        key={ name }
        type="button"
        className={ cn(tabsStyles.tab, {
          [tabsStyles.isTabActive]: name === activeTab,
          [tabsStyles.isTabDisabled]: !isAccessible && name !== activeTab,
        }) }
        onClick={ isAccessible ? () => onClick(name) : undefined }
        data-test={ `topCompaniesTabs${ upperFirst(name) }` }
      >
        { title }
      </button>
    )) }
  </>
);

export default TopCompaniesTabs;
